import { ExamEventDetailsProvider } from '@exam-center/exam-event-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  ExamEventSessionDetailsProvider,
  ProctoringDetailsModalProvider,
  ProctoringExamSessionDetailsPageHeader,
} from '@exam-center/proctoring-details';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ProctoringExamSessionDetailsLayout() {
  const {
    examCenterCode,
    examEventId,
    examSessionId: examEventSessionId,
  } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId/details/session/:examSessionId',
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTORING.DETAILS.VIEW}>
      <ExamEventDetailsProvider examCenterCode={examCenterCode} examEventId={examEventId}>
        <ExamEventSessionDetailsProvider
          examCenterCode={examCenterCode}
          examEventId={examEventId}
          examEventSessionId={examEventSessionId}
        >
          <ProctoringDetailsModalProvider>
            <ProctoringExamSessionDetailsPageHeader />
            <Outlet />
          </ProctoringDetailsModalProvider>
        </ExamEventSessionDetailsProvider>
      </ExamEventDetailsProvider>
    </PermissionGuard>
  );
}
